import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 原JS+CSS
import '@/assets/css/css.css'
import '@/assets/js/tool'
import '@/assets/css/code.css'
import '@/assets/js/code'
// layer弹出层
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';

Vue.prototype.$layer = layer(Vue);

// 全局URL配置文件
import URL from '@/core/globalUrl'

Vue.prototype.$URL = URL;

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');